import { render, staticRenderFns } from "./BankUndepositedFundSummary.vue?vue&type=template&id=a510ffbc"
import script from "./BankUndepositedFundSummary.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports